var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoStatsFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.686 183.737C163.31 187.759 173.433 184.977 180.251 178.34C189.919 168.929 201.484 161.457 214.318 156.554C223.203 153.159 230 145.164 230 135.652V27.4856C230 15.8048 220.005 6.53687 208.491 8.50185C142.38 19.784 85.303 57.5527 48.5657 110.501C41.902 120.105 46.0737 133.091 56.6679 138.031L154.686 183.737ZM150.24 243.011C150.893 233.553 146.513 224.061 137.92 220.055L39.7909 174.296C29.1908 169.353 16.5543 174.512 13.4972 185.802C7.95639 206.263 5 227.786 5 250C5 325.708 39.3397 393.396 93.293 438.337C102.28 445.823 115.591 442.803 121.439 432.674L175.527 338.991C180.278 330.762 178.402 320.452 172.404 313.083C158.397 295.875 150 273.918 150 250C150 247.65 150.081 245.32 150.24 243.011ZM234.16 348.752C224.775 347.259 214.904 350.788 210.153 359.018L156.045 452.734C150.203 462.853 154.226 475.878 165.188 479.923C191.615 489.674 220.186 495 250 495C385.31 495 495 385.31 495 250C495 128.84 407.052 28.2219 291.514 8.50255C279.999 6.53737 270 15.8048 270 27.4856V135.652C270 145.164 276.799 153.16 285.685 156.555C323.291 170.924 350 207.343 350 250C350 305.228 305.228 350 250 350C244.61 350 239.319 349.573 234.16 348.752Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStatsFill);
export default __webpack_public_path__ + "static/media/ico_stats_fill.59096a4ae33aeb14e1ede6a0a8b68388.svg";
export { ForwardRef as ReactComponent };